'use client';

import { useAccountInfo } from './account';
import { useAtomValue } from 'jotai';
import { visitorAtom } from '@/atoms/visitor';
import { ApiBackendInfo } from './athena/types';
import { useMemo } from 'react';


export const useApiBackendInfo = () => {
	const { user } = useAccountInfo();
	const visitorInfo = useAtomValue(visitorAtom);
	return useMemo(() => {
		const url = user ? user.ApiBackendUrl : (visitorInfo?.ApiBackendUrl ?? '');
		const token = user ? (user.AccessToken ?? '') : (visitorInfo?.OneAccessToken ?? '');
		const apiBackendInfo: ApiBackendInfo = {
			url,
			token,
			isReady: url !== '' && token !== '',
			isBefore: !user 
		};
		return apiBackendInfo;
	}, [user?.AccessToken, user?.ApiBackendUrl, visitorInfo?.ApiBackendUrl, visitorInfo?.OneAccessToken])
}